export default __webpack_public_path__ + "static/media/janani.6ee38a1b.png";